import { render, staticRenderFns } from "./ProductSingle.vue?vue&type=template&id=043d4b32&scoped=true"
import script from "./ProductSingle.vue?vue&type=script&lang=js"
export * from "./ProductSingle.vue?vue&type=script&lang=js"
import style0 from "./ProductSingle.vue?vue&type=style&index=0&id=043d4b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043d4b32",
  null
  
)

export default component.exports